import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import 'react-day-picker/lib/style.css';
import moment from 'moment';
import { isValueEntered } from 'services/Validation';
import { isDateBefore } from 'services/DateService';
import {
    showFeatureLoader,
    onSaveFeature,
    onFeatureClose,
} from 'actions/feature';
import { inputFields, displayedImage, showErrors, modalHeader } from '../common';

const FeatureAdd = () => {
    const dispatch = useDispatch();
    const addFeatureState = useSelector(state => state.features.addFeatureState);
    const [selectedFeature, setSelectedFeature] = useState(initProps);
    const [formErrors, setFormErrors] = useState({ name: '', description: '', initiative: '' });
    const [formValid, setFormValid] = useState(false);
    const initiatives = useSelector(state => state.initiatives.allInitiative);

    useEffect(() => {
        setSelectedFeature(initProps());
    }, []);

    // using selectedFeature makes it behave like componentDidUpdate - effect takes place when selectedFeature changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedFeature]);

    const initProps = () => {
        return {
            id: '',
            orgid: '',
            name: '',
            description: '',
            priority: '',
            initiativeId: '',
            successIndicators: '',
            dependencies: [],
            startDate: '',
            endDate: '',
            starred: false,
            frequently: false,
        };
    };

    const handleUserInput = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        // console.log('handleUserInput start '.concat(selectedFeature?.name).concat(' - ').concat(selectedFeature?.description).concat(' - ').concat(selectedFeature?.initiativeId).concat(' - '));
        updateSelectedFeatureField(name, value);
        // console.log('handleUserInput end '.concat(selectedFeature?.name).concat(' - ').concat(selectedFeature?.description).concat(' - ').concat(selectedFeature?.initiativeId).concat(' - '));
        validateField(name, value);
    };

    const handleDateInput = (fieldName, value) => {
        updateSelectedFeatureField(fieldName, value);
        validateForm();
    };

    const updateSelectedFeatureField = (fieldName, value) => {
        const newFeature = { ...selectedFeature };
        newFeature[fieldName] = value;
        setSelectedFeature(newFeature);
    };

    const checkDatesValid = () => {
        let fieldValidationErrors = formErrors;
        if (isValueEntered(selectedFeature?.endDate) && isValueEntered(selectedFeature?.startDate)) {
            // DayPickerInput gives a format that DateService does not like so utilise moment as the default before passing to the date check
            if (isDateBefore(moment(selectedFeature?.endDate), moment(selectedFeature?.startDate))) {
                fieldValidationErrors.dates = ' are invalid. The end date selected cannot be before the start date';
                setFormErrors(fieldValidationErrors);
                return false;
            }
            fieldValidationErrors.dates = '';
            setFormErrors(fieldValidationErrors);
            return true;
        }
        return true; // dates are not mandatory on features so dont return false - just check start is before end date
    };

    const validateField = (fieldName, value) => {
        const valueEntered = isValueEntered(value);
        formErrors[fieldName] = valueEntered ? '' : ' is invalid';
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        // console.log('validateForm '.concat(selectedFeature?.name).concat(' - ').concat(selectedFeature?.description).concat(' - ').concat(selectedFeature?.initiativeId).concat(' - '));
        // console.log('validateForm '.concat(isValueEntered(selectedFeature?.name) && checkDatesValid() && isValueEntered(selectedFeature?.description) && isValueEntered(selectedFeature?.initiativeId)));
        setFormValid(isValueEntered(selectedFeature?.name) && checkDatesValid() && isValueEntered(selectedFeature?.initiativeId));
    };


    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showFeatureLoader());
                dispatch(onFeatureClose());
                dispatch(onSaveFeature(selectedFeature));
                setSelectedFeature(initProps());
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onFeatureClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedFeature)}
                        {showErrors(formErrors)}
                        {inputFields(selectedFeature, initiatives, handleUserInput, handleDateInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={addFeatureState}>
            {modalHeader(<IntlMessages id="feature.addFeature" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="feature.addFeature" />)}
        </Modal>
    );
};

export default FeatureAdd;


// WEBPACK FOOTER //
// ./components/Agile/feature/featureMaintenance/featureAdd/index.js